module.exports = __webpack_public_path__ + "static/media/storefront.4e55f396.svg";